// TEMP_BRIDGE
module.exports = require("./App" + ".tsx");
